module.exports = { "default": require("core-js/library/fn/object/set-prototype-of"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// /app/node_modules/babel-runtime/core-js/object/set-prototype-of.js
// module id = 848
// module chunks = 0